
export const BusinessNavigation = [
	{
		icon: 'pe-7s-graph',
		label: 'Dashboard',
		to: '/secure/business-dashboard'
	},
	{
		icon: 'pe-7s-tools',
		label: 'Settings',
		content: [
			{
				label: 'Auction Durations',
				to: '/secure/auction-durations'
			}
		]
	},
	{
		icon: 'pe-7s-map-2',
		label: 'Auction Templates',
		to: '/secure/auction-templates-listing'
	},
	{
		icon: 'pe-7s-ticket',
		label: 'Auctions',
		to: '/secure/auctions-search'
	},
	{
		icon: 'pe-7s-car',
		label: 'Vehicles',
		to: '/secure/business-vehicles-search'
	},
	{
		icon: 'pe-7s-news-paper',
		label: 'Reports',
		content: [
			{
				label: 'Sales Report',
				to: '/secure/business-sales-report'
			},
			{
				label: 'Listing Report',
				to: '/secure/business-listing-report'
			}
		]
	}
]

export const DealerNavigation = [
	{
		icon: 'pe-7s-graph',
		label: 'Dashboard',
		to: '/secure/dealer-dashboard'
	},
	{
		icon: 'pe-7s-ticket',
		label: 'Auctions',
		to: '/secure/dealer-auction-listing?view=auctions'
	},
	{
		icon: 'pe-7s-wristwatch',
		label: 'Watchlist',
		content: [
			{
				label: 'Vehicles',
				to: '/secure/dealer-vehicle-watchlist'
			}
		]
	},
	{
		icon: 'pe-7s-car',
		label: 'Owned Vehicles',
		to: '/secure/owned-vehicles'
	}
]
